module.exports = __webpack_public_path__ + "assets/img/DataStore.5ee6b7ef.svg";